/* unplugin-vue-components disabled */import script from "./tenth.vue?vue&type=script&setup=true&lang=js"
export * from "./tenth.vue?vue&type=script&setup=true&lang=js"

import "./tenth.vue?vue&type=style&index=0&id=1d511adc&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d511adc"]])

export default __exports__